import { defineComponent } from 'vue'
// import ProductListItemGrid from '@/components/organisms/product-list/product-list-item-grid/default';
// import ProductListItemGridMobile from "@/components/organisms/product-list/product-list-item-grid/mobile";
// import ItemContainer from "@/containers/panier/item";
import panierMapper from "@/services/panier/panier-mapper";
import { useMagasinStore } from '@/store/magasin';
import { usePanierStore } from '@/store/panier';
import { useNotificationsStore } from '@/store/notifications';
import { useContextStore } from '@/store/context';
import { useAuthStore } from '@/store/auth';
import { useClientStore } from '@/store/client';

export default defineNuxtPlugin(({ $apiDrive, $pinia, $partenairesEvents }) => {
  const config = useRuntimeConfig();
  const apiConfig = $apiDrive.getConfig();

  const magasinStore = useMagasinStore($pinia);
  const panierStore = usePanierStore($pinia);
  const notificationsStore = useNotificationsStore($pinia);
  const contextStore = useContextStore($pinia);
  const authStore = useAuthStore($pinia);
  const clientStore = useClientStore($pinia);

  const router = useRouter();
  const route = useRoute();

  window.cora = {
    context: {
      version: config.public.VERSION
    }
  };
  window.cora.partenaires = {};
  window.cora.partenaires.api = (nomPartenaire = 1) => {
    return {
      get: (path) => {
        const config = { ...apiConfig };
        config.headers["app-partner"] = nomPartenaire;
        return $apiDrive.get(path, config)
      }
    }
  };
  window.cora.partenaires.products = {};

  window.cora.partenaires.panier = {
    add: (articles, codePartenaire = null, codeOperation = null) => {
      if (!Array.isArray(articles) || magasinStore.isNational) {
        return;
      }
      const errors = []
      const produits = articles.reduce((produits, article) => {
        const produit = panierMapper.getArticleModel(article);
        if (codePartenaire) {
          produit.code_partenaire = codePartenaire;
        }
        if (codeOperation) {
          produit.code_operation = codeOperation;
        }
        try {
          panierMapper.checkArticleModel(produit);
          produits.push(produit);
        } catch (error) {
          errors.push(error);
        }
        return produits;
      }, []);

      if (produits.length > 0) {
        panierStore.syncArticles(produits);
      }
      if (errors.length > 0) {
        throw new Error(errors);
      }
    },

    sendToNotificationZone: (notification) => {
      notificationsStore.sendToNotificationZone(notification);

    },
    getArticles: () => {
      return panierStore.lignes.map(article => ({ ...article }));
    },
    getMontant: () => {
      return panierStore.montantTotalTTC;
    },
    onChanged: (cb) => {
      return $partenairesEvents.subscribe("panierChanged", cb);
    },
    getId: () => {
      return panierStore.id;
    }
  };

  window.cora.partenaires.router = {
    push: (path) => {
      router.push(path);
    },
    onPageLoaded(cb) {
      return $partenairesEvents.subscribe("page-loaded", cb, true);
    },
    onProductsListLoaded(cb) {
      return $partenairesEvents.subscribe("products-list-loaded", cb, true);
    },
    getRoutePath() {
      return route.path;
    },
    getRoutes() {
      return router.getRoutes();
    }
  };
  window.cora.partenaires.context = {
    get magasinId() {
      return magasinStore.id;
    },
    get isMagasinNational() {
      return magasinStore.isNational;
    },
    get layout() {
      return contextStore.layout;
    },
    async switchMagasin(id) {
      try {
        await magasinStore.switchMagasin(id);
      } catch { }
      router.go();
    },
    showStoreLocator() {
      magasinStore.displayStoreLocator();
    }
  };

  window.cora.partenaires.user = {
    get isLogged() {
      return authStore.isLogged;
    },
    get isPro() {
      return clientStore.isPro;
    },
    get id() {
      return clientStore.client ? clientStore.client.id : null;
    },
    onLogin(cb) {
      return $partenairesEvents.subscribe("login", cb);
    },
    onLogout(cb) {
      return $partenairesEvents.subscribe("logout", cb);
    }
  };

  window.cora.partenaires.products.createTile = (product) => { return createVignetteElement(product, app, router, contextStore.layout) };
});

/**
  * Créé une vignette sous forme d'objet HTMLElement qui peut être ajouté au DOM
  * @param product
  * @param configPartenaire
  * @returns {*|HTMLElement}
  */
/* eslint-disable */
const createVignetteElement = (product, app, router, layout) => {
  const componentClass = defineComponent({
    extends: ItemContainer
  });
  const itemGridClass = getVignetteClass(layout);

  // TODO : voir avec Gautier / Theodo

  // const vignette = new componentClass({
  //   propsData: {
  //     article: product,
  //     component: itemGridClass,
  //     position: "Partenaire externe : Criteo"
  //   },
  //   ...app.context,
  //   router
  // });
  // vignette.$mount();
  // return vignette.$el;
}

const getVignetteClass = layout => {
  if (layout === "mobile") {
    return defineComponent({
      extends: ProductListItemGridMobile
    });
  } else {
    return defineComponent({
      extends: ProductListItemGrid
    });
  }
};
